<template>
  <div class="content container-fluid">
    <div class="conf-box">
      <div class="step-info d-flex align-items-center justify-content-between">
        <div>
          <div class="count-step">
            Ihre Bestellung
          </div>
          <div class="name-step">
            Ihre aktuelle
            Vorauswahl
          </div>
          <div class="description-step">
            Ihre aktuelle
            Vorauswahl
          </div>
        </div>
      </div>
      <preview-box />
      <info-box />
      <price-box />
      <div class="text-center">
        <p class="ink">
          inkl. 19% MwSt. &amp; Versandkosten
        </p>
        <button type="button" class="btn btn-primary btn-sm" @click="addToCart">
          In den Warenkorb
        </button>&nbsp;
        <button type="button" class="btn btn-outline-success btn-sm" @click="showModal">
          Unverbindliche Anfrage
        </button>
      </div>
    </div>
    <step-container />
    <steps-arrow />
    <b-modal ref="bv-modal-request" size="xl" hide-footer>
      <template v-slot:modal-title>
        Unverbindliche Anfrage
      </template>
      <div v-if="reqForm" class="d-block text-center">
        <b-form-group>
          <b-form-input id="username" v-model.trim="$v.form.name.$model" type="text" required placeholder="Vor- und Nachname *" :class="{ 'is-invalid': $v.form.name.$error }" />
        </b-form-group>
        <b-form-group>
          <b-form-input id="email" v-model.trim="$v.form.email.$model" type="email" required placeholder="E-Mail-Adresse *" :class="{ 'is-invalid': $v.form.email.$error }" />
        </b-form-group>
        <b-form-group>
          <b-form-input id="phone" v-model.trim="$v.form.phone.$model" type="text" required placeholder="Telefon *" :class="{ 'is-invalid': $v.form.phone.$error }" />
        </b-form-group>
        <b-form-group>
          <b-form-input id="address" v-model.trim="$v.form.address.$model" type="text" required placeholder="Adresse *" :class="{ 'is-invalid': $v.form.address.$error }" />
        </b-form-group>
        <b-form-group>
          <b-form-input id="city" v-model.trim="$v.form.city.$model" type="text" required placeholder="PLZ, Stadt *" :class="{ 'is-invalid': $v.form.city.$error }" />
        </b-form-group>
        <b-form-group>
          <b-form-textarea id="message" v-model.trim="$v.form.message.$model" type="text" required placeholder="Nachricht *" :class="{ 'is-invalid': $v.form.message.$error }" />
        </b-form-group>
        <b-form-group label="Hier können Sie Bilder von Umgebung oder Skizzen als Anhänge hinzufügen.">
          <b-form-file ref="docs0" name="docs[]" accept=".png, .jpg, .jpeg, .pdf, .doc, .docx" />
          <b-form-file ref="docs1" name="docs[]" accept=".png, .jpg, .jpeg, .pdf, .doc, .docx" />
          <b-form-file ref="docs2" name="docs[]" accept=".png, .jpg, .jpeg, .pdf, .doc, .docx" />
        </b-form-group>
        <b-button class="btn btn-primary" block :disabled="sending" type="submit" @click="sendRequest">
          <b-spinner v-if="sending" small type="grow" />
          Anfrage stellen
        </b-button>
        <b-button class="btn btn-secondary" block @click="$bvModal.hide('bv-modal-example')">
          Schließen
        </b-button>
      </div>
      <div v-if="success" class="alert alert-success" role="alert">
        Vielen Dank für Ihre Anfrage und das damit verbundene Interesse an unserem Unternehmen. Ein Mitarbeiter von der Verkaufs-Abteilung wird sich mit Ihnen kurzfristig in Verbindung setzen.
      </div>
    </b-modal>
  </div>
</template>

<script>
import InfoBox from './configurator/infoBox'
import PriceBox from './configurator/priceBox'
import StepContainer from './configurator/stepContainer'
import StepsArrow from './configurator/stepsArrow'
import ImagePreview from './configurator/previewBox'

import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  layout: 'basic',
  metaInfo () {
    return { title: this.name }
  },
  components: {
    'preview-box': ImagePreview,
    'info-box': InfoBox,
    'price-box': PriceBox,
    'step-container': StepContainer,
    'steps-arrow': StepsArrow
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: { required },
      email: { required, email },
      phone: { required },
      address: { required },
      city: { required },
      message: { required }
    }
  },
  data: () => ({
    title: window.config.appName,
    form: {
      name: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      message: ''
    },
    sending: false,
    reqForm: true,
    success: false
  }),
  computed: {
    ...mapGetters({
      name: 'configurator/name',
      steps: 'configurator/steps',
      summary: 'configurator/summary',
      countries: 'checkout/countries'
    }),
    formData () {
      return {
        ...this.form,
        summary: this.summary
      }
    }
  },
  mounted () {
    this.getConfigurator()
    if (this.countries === null) {
      this.setDeliveryCountries()
    }
  },
  methods: {
    ...mapActions({
      setConfigurator: 'configurator/setConfigurator',
      addItem: 'checkout/addItem',
      setDeliveryCountries: 'checkout/setDeliveryCountries'
    }),
    async getConfigurator () {
      const apiKey = btoa(process.env.VUE_APP_API_KEY)
      const apiUrl = process.env.VUE_APP_API_URL
      const currentConfigurator = (typeof this.$router.currentRoute.params.name === 'undefined') ? 'schiebetore' : this.$router.currentRoute.params.name
      const { data } = await axios.post(apiUrl + 'configurator/domain', { re: apiKey, name: currentConfigurator })
      if (data) {
        this.setConfigurator(data)
      }
    },
    addToCart () {
      this.addItem(this.summary)
      this.$router.push({ name: 'checkout.cart' })
    },
    showModal () {
      this.$refs['bv-modal-request'].show()
    },
    async sendRequest () {
      this.sending = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const file0 = this.$refs.docs0.selectedFile
        const file1 = this.$refs.docs1.selectedFile
        const file2 = this.$refs.docs2.selectedFile

        const fd = new FormData()
        if (typeof file0 !== 'undefined') {
          fd.append('docs[' + 0 + ']', file0)
        }
        if (typeof file1 !== 'undefined') {
          fd.append('docs[' + 1 + ']', file1)
        }
        if (typeof file2 !== 'undefined') {
          fd.append('docs[' + 2 + ']', file2)
        }
        for (const key in this.formData) {
          if (key === 'summary') {
            fd.append('summary', JSON.stringify(this.formData[key]))
          } else {
            fd.append(key, this.formData[key])
          }
        }
        fd.append('re', btoa(process.env.VUE_APP_API_KEY))
        const apiUrl = process.env.VUE_APP_API_URL
        await axios.post(apiUrl + 'quickorder', fd, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(resp => {
          if (resp.data) {
            this.sending = false
            this.reqForm = false
            this.success = true
          } else {
            this.sending = false
            this.success = false
            this.reqForm = true
          }
        })
      } else {
        this.sending = false
      }
    }
  }
}
</script>
